import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import { H4 } from '../text';

import styles from './calendar.styles';

function CalendarMonthHeader(props) {
  const { name, year, weekdayNames, languageCode, messages} = props;

  return (<View testID="month-header">
    {languageCode == 'en' || languageCode == undefined ?
      <H4 style={styles.calendarMonthHeaderText} testID="name">
        {name} {year}
      </H4>
      :
      <H4 style={styles.calendarMonthHeaderText} testID="name">
        {year}{messages['app.calendar.year']} {name}
      </H4>
    }
    <div className="calendar-month-header">
      {
        weekdayNames.map((weekdayName, index) => (<span key={index} className="calendar-week-header calender-week-text">
        { weekdayName }
        </span>))
      }
    </div>
  </View>);
}

CalendarMonthHeader.propTypes = {
  name: PropTypes.string.isRequired,
  weekdayNames: PropTypes.arrayOf(PropTypes.string),
  year: PropTypes.number.isRequired,
};

export default pure(CalendarMonthHeader);


